import { AdvancedMarker, APIProvider, Map } from '@vis.gl/react-google-maps';
import { FC, useEffect, useState } from 'react';
import MapPolygon from './components/MapPolygon.tsx';
import MapBoundary from './components/MapBoundary.tsx';
import MapSearch from './components/MapSearch.tsx';
import SearchedAddressInfo from './components/SearchedAddressInfo.tsx';
import CompanyAdvanceMarker from './components/CompanyAdvanceMarker.tsx';
import { Box, Button, IconButton, Typography } from '@material-ui/core';
import useZonesAndMarkers from './hooks/useZonesAndMarkers.ts';
import { Marker } from './interface.tsx';

const API_KEY = 'AIzaSyCvOQLQzL6EoVq6Kh8z6V3CE0HnoXKspfk';

interface GeofenceProps {
  searchedAddress?: string | null;
  customerId?: string | null;
}

const Geofence: FC<GeofenceProps> = ({
  searchedAddress,
  customerId,
}) => {

  const urlParams = new URLSearchParams(window.location.search);
  const mapname = urlParams.get('mapname');
  const address = urlParams.get('address');

  const [searchedMarkerPosition, setSearchedMarkerPosition] = useState<{
    lat: number;
    lng: number;
  } | null>(null);

  const [searchedAddressName, setSearchedAddressName] = useState<string | null>(null);

  const { data: zonesAndMarkers, isLoading, error, fetchZonesAndMarkers } = useZonesAndMarkers();

  useEffect(() => {
    if (customerId) {
      fetchZonesAndMarkers(customerId, mapname || '');
    }
  }, [customerId, mapname]);


  const searchAddressResult = null;


  const handlePlaceSelect = (place: google.maps.places.PlaceResult) => {
    if (place.geometry && place.geometry.location) {
      const position = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };

      if (
        searchedMarkerPosition &&
        searchedMarkerPosition.lat === position.lat &&
        searchedMarkerPosition.lng === position.lng
      ) {
        return;
      }

      setSearchedAddressName(place.formatted_address ?? null);
      setSearchedMarkerPosition(position); // Update marker position
    }
  };

  const handleStartOver = () => {
    setSearchedAddressName(null);
    setSearchedMarkerPosition(null);
  }

  return (
    <APIProvider apiKey={API_KEY}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          height: '100vh',
        }}
      >
          <Box sx={{ 
            flex: 3 }}>
            <Map
              key={'geofence-map'}
              defaultZoom={6}
              defaultCenter={{ lat: 39.8283, lng: -98.5795 }} // Center of the US
              gestureHandling={'greedy'}
              disableDefaultUI={true}
              mapId={'6c213c088b16f9bc'}
            >
              {/* Search address marker */}
              {searchedMarkerPosition && <AdvancedMarker position={searchedMarkerPosition} />}

              {/* Custom Markers */}
              {zonesAndMarkers?.markers &&
                zonesAndMarkers?.markers.map((marker: Marker, index) => {
                  const location = marker.coordinate;
                  if (location?.lat && location?.lng) {
                    return (
                      <CompanyAdvanceMarker
                        key={`marker-${index}`}
                        index={index}
                        label={marker.markerName ?? ''}
                        coordinates={location}
                      />
                    );
                  }
                  return null;
                })}


              <MapPolygon zones={zonesAndMarkers?.zones || []} />
              <MapBoundary
                zones={zonesAndMarkers?.zones || []}
                searchedMarkerPosition={searchedMarkerPosition}
                companies={zonesAndMarkers?.markers || []}
                focusOnSearchedMarker={true}
              />
            </Map>
          </Box>

        {/* Side Bar */}
        <Box
          sx={{
            flex: 1,
            flexDirection: 'column',
            padding: 1,
            //backgroundColor: '#f9f9f9',
            borderLeft: '2px solid #ddd',
          }}
        >

          {/* Title and back button */}
          <Box
            sx={{
              padding: 2,
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <IconButton onClick={() => console.log('back')}>
              {/* <ArrowBackIcon /> */}
            </IconButton>

            <Typography variant="h6" style={{ fontWeight: 'bold' }}>
              Map Search
            </Typography>
            <Box></Box>
          </Box>

          {/* Search */}
          <Box sx={{ padding: 1, margin: 10 }}>
            {
              error && (
                <Typography color="error" variant="body2" style={{ marginBottom: 10 }}>
                  {error}
                </Typography>
              )
            }


            {/* Auto complete search input field */}
            <MapSearch
              searchAddressResult={searchAddressResult}
              onPlaceSelect={handlePlaceSelect}
              clearSearch={searchedMarkerPosition === null}
            />

            <Button
              variant="outlined"
              color="primary"
              onClick={handleStartOver}
              style={{ marginTop: 10 }}
              disabled={!searchedMarkerPosition}
            >
              Start Over
            </Button>
          </Box>

          {/* Searched Address Info */}
          {searchedAddressName && searchedMarkerPosition && (
            <Box sx={{ padding: 1, margin: 10 }}>
              <SearchedAddressInfo
                address={searchedAddressName}
                coordinates={searchedMarkerPosition}
              />
            </Box>
          )}
        </Box>
      </Box>
    </APIProvider>
  );
};

export default Geofence;
